var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_13261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8416 65.6811C79.1179 51.2217 79.1179 27.7783 64.8416 13.3189C50.5652 -1.14052 27.4186 -1.14052 13.1422 13.3189C-1.13422 27.7783 -1.13422 51.2217 13.1422 65.6811C27.4186 80.1405 50.5652 80.1405 64.8416 65.6811Z",
    fill: "#46CC6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0362 45.782C72.4346 61.1994 60.4243 73.363 45.2025 75.9981L25.5196 56.0628C20.8096 52.1259 17.8076 46.1681 17.8076 39.5C17.8076 27.6455 27.2956 18.0359 39 18.0359C45.5837 18.0359 51.4661 21.0765 55.3532 25.8467L75.0362 45.782Z",
    fill: "#179C5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0803 40.7745L35.1158 46.3881C35.9962 47.209 37.359 47.1653 38.1869 46.3006L48.9545 35.8592C49.8303 35.0062 49.8568 33.595 49.0143 32.7075C48.1719 31.8214 46.7793 31.7936 45.9035 32.6466L36.5767 41.691L32.062 37.4921C31.1676 36.6586 29.7741 36.7171 28.9506 37.6239C28.1274 38.5298 28.1854 39.9402 29.0803 40.7745ZM39 18.0359C50.7044 18.0359 60.1924 27.6455 60.1924 39.5C60.1924 51.3545 50.7044 60.9641 39 60.9641C27.2956 60.9641 17.8076 51.3545 17.8076 39.5C17.8076 27.6455 27.2956 18.0359 39 18.0359Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_13261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.6354f3bee79c44334f8e7d2fdbfb2366.svg";
export { ForwardRef as ReactComponent };